import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Divider,
  Grid,
  Typography,
} from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import React from 'react';
import { data } from './faqData';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export default function SupportTab() {
  return (
    <Grid container>
      <Grid item xs={0} md={3} />
      <Grid item container xs={12} md={6} spacing={4}>
        <Grid item container spacing={2} sx={styles.centered}>
          <Grid item>
            <EmailIcon />
          </Grid>
          <Grid item>
            <Typography>{'support@procurefix.com'}</Typography>
          </Grid>
        </Grid>
        <Grid item container spacing={2} sx={styles.centered}>
          <Grid item>
            <PhoneIcon />
          </Grid>
          <Grid item>
            <Typography>{'(832) 392-2149'}</Typography>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Divider />
        </Grid>

        <Grid item container spacing={2}>
          <Grid item>
            <Typography variant={'h6'}>FAQs</Typography>
          </Grid>
          <Grid item>
            {data.map((section, index) => (
              <Accordion key={index}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography>{section.title}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  {section.items.map((item, index2) => (
                    <Grid item container key={index2} padding={2}>
                      <Grid item>
                        <Typography fontWeight={'bold'}>{item.title}</Typography>
                      </Grid>
                      <Grid item>
                        <Typography>{item.description}</Typography>
                      </Grid>
                    </Grid>
                  ))}
                </AccordionDetails>
              </Accordion>
            ))}
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={0} md={3} />
    </Grid>
  );
}

const styles = {
  centered: {
    alignItems: 'center',
    justifyContent: 'center',
  },
};
